<div class="sidebar fixed top-[88px] flex flex-col justify-between bottom-[0px] lg:left-0 primary-background transition-all duration-500 z-40"
     [ngClass]="isOpenSidebar ? 'w-[260px] overscroll-auto' : 'w-[72px] h-[56px] md:h-auto'">
  <div class="flex flex-col justify-start h-full">
    <div class="w-full flex flex-row justify-start items-center hover:bg-gray-400 cursor-pointer h-[56px]" matRipple
         (click)="openSidebar()">
      <div class="flex flex-row items-center justify-center py-2 px-6 ml-1"
           [ngClass]="isOpenSidebar ? 'flex ' : 'hidden '">
        <div class="w-18 h-18 justify-center items-center">
          <img [src]="openMenu" alt="" />
        </div>
        <div class="w-18 h-18 justify-center items-center">
          <img [src]="iconMenu" alt="" />
        </div>
        <span [ngClass]="isOpenSidebar ? 'flex ' : 'hidden '" class="text-white truncate ml-4">
          {{ 'Close' | translatei18n }}
        </span>
      </div>
      <div class="flex flex-row items-center justify-center px-6 mt-2" [ngClass]="isOpenSidebar ? 'hidden ' : ' flex '"
           [matTooltip]="!isOpenSidebar ? ('openSideNav' | translatei18n ) || '' : ''" [matTooltipPosition]="'right'">
        <div class="justify-center items-center text-white">
          <mat-icon>menu_open</mat-icon>
        </div>
      </div>
    </div>
    <div class="overflow-y-auto flex-1">
      <ng-container *ngFor="let category of stepMenu">
        <ng-container *ngIf="category.itemType !== 'SectionTab'">
          <ng-container *ngTemplateOutlet="menuOption; context: { menu: category }"></ng-container>
        </ng-container>
        <ng-container *ngIf="category.itemType == 'SectionTab'">
          <ng-container *ngTemplateOutlet="sectionTab; context: { section: category }"></ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <div matRipple class="h-[50px] mb-6 w-full flex flex-col justify-center items-center transition-all duration-500 text-white" [ngClass]="isOpenSidebar ? '': 'hidden'">
    <a (click)="openHelpDesk()">{{'HELP DESK' | translatei18n }} </a>
  </div>
</div>
<div class="sidenavBackdrop" [ngClass]="isOpenSidebar ? 'open' : 'closed'" (click)="openSidebar()"></div>

<ng-template #menuOption let-menu="menu">
  <div>
    <span [ngClass]="menu.displayName === selectedPage?.displayName ? 'bg-gray-400/30 ' : 'bg-transparent'"
          class="w-full flex flex-row justify-start items-center hover:bg-gray-400 cursor-pointer py-4"
          matRipple (click)="selectMenuItem(menu)" [matTooltip]="!isOpenSidebar ? (menu.displayName | translatei18n ) : ''"
          [matTooltipPosition]="'right'">
      <div class="flex flex-row items-center justify-center px-5">
        <mat-icon class="text-white"
                  [ngClass]="(menu.displayName === selectedPage?.displayName ? 'material-icons' : 'material-icons-outlined') + (shouldBlink(menu.iconName) && isBlinking ? ' blink' : '')">
          {{ menu.iconName }}
        </mat-icon>
      </div>
      <span [ngClass]="isOpenSidebar ? 'flex ' : 'hidden '" class="text-white truncate">
        {{ menu.displayName | translatei18n }}
      </span>
    </span>
  </div>
</ng-template>

<ng-template #sectionTab let-section="section">
  <div class="m-2.5 py-6 flex items-center px-4 text-white h-1">
    <span [ngClass]="isOpenSidebar ? 'flex ' : 'hidden '" class="text-[19px] font-bold border-b-2 w-full pb-1">
      {{ section.displayName | translatei18n }}
    </span>
  </div>
  <ng-container *ngFor="let item of section.children">
    <ng-container *ngTemplateOutlet="menuOption; context: { menu: item }"></ng-container>
  </ng-container>
</ng-template>
